export default __webpack_public_path__ + "static/media/linux.67aa336b.svg";